import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
/* eslit-disable */
import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import CheckableInput from 'components/CheckableInput';
import { setStorage } from 'utilz';
import { URLS } from 'config';

import './styles.scss';
import containerActions from './actions';

import UploadProgress from './UploadProgress';

import UploadType from './UploadType';
import Success from './Success';

class UploadPage extends React.Component {
	state = {
	  modalOpen: false,
	  errorDownload: false,
	  errorMessage: ''
	}

	componentWillMount() {
	  this.props.fileList((listLength) => {
	    if (listLength >= 2) {
	      this.props.history.push(URLS.DOWNPAYMENTS);
	      // this.props.history.push(URLS.SEARCH);
	    }
	  });
	}

  types = [
    {
      type: 0,
      text: 'Driver\'s license * mandatory'
    },
    {
      type: 1,
      text: 'Paystub photo'
    },
    {
      type: 2,
      text: 'Last 3 months of bank account activity'
    }
  ]


  saveStorage = () => {
    setStorage({
      file: {
        type1: this.props.type1,
        type2: this.props.type2,
        step: this.props.step,
        loading: false,
        progress: 0,
        done: false
      }
    });
  }

  selectHandl = (e) => {
    this.props.fileTypeChange(+e.target.value);
    this.saveStorage();
  }

  emailSentHandl = (e) => {
    e.preventDefault();
    this.props.fileNotificationLater(() => {
      this.props.showNotification({
        title: 'Link sent to your email',
        callback: () => {
          this.props.history.push(URLS.DOWNPAYMENTS);
          // this.props.history.push(URLS.SEARCH);
        }
      });
    });
  }


  modalHandl = () => {
    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen
    }));
  }

  sendData = (file) => {
    this.props.fileSend((status) => {
      this.modalHandl();
      // if (this.props.step === 3) {
      //   this.props.history.push(URLS.SEARCH);
      // }
      if (status.status === 200) {
        this.saveStorage();
        this.props.fileStepChange();
      }
      if (status.status === 400) {
        this.setState({
          errorDownload: true,
          errorMessage: status.data.message
        });
      }
    }, file);
  }
  closeErrorWindow = () => {
    this.setState({
      errorDownload: false
    });
  }
  render () {
    return (
      <React.Fragment>
        {
          this.props.step === 3 && !this.props.done ?
            <Success
              types={this.types}
              uploaded={this.props.uploaded}
              getList={this.props.fileList}
              confirmationChangeHandl={this.props.confirmationChangeHandl}
              confirmationSend={this.props.confirmationSend}
              workingChangeHandl={this.props.workingChangeHandl}
            />
            : null
        }
        <div className="page-upload -not-full">
          <div className="upload-wrapper">
            <div className="upload-image">
              <i className="icon-cloud-upload" />
            </div>
            <PageTitle>
            Upload 2 of the following required documents
            </PageTitle>

            <div className="upload-list">
              {
              this.types.map(el => (
                <CheckableInput
                  key={el.type}
                  name="type"
                  changeHandl={this.selectHandl}
                  value={el.type}
                  disabled={el.type === this.props.type1 && this.props.step === 2}
                  checked={el.type === this.props[`type${this.props.step}`]}
                >
                  { el.type === this.props.type1 && this.props.step === 2
                      ? <i className="material-icons">check</i> : '' }
                  {el.text}
                </CheckableInput>
                ))
            }
            </div>

            <Button
              disabled={this.props[`type${this.props.step}`] === false}
              onClick={this.modalHandl}
            >
			Process to upload
            </Button>

            <a href="#" className="upload-sent" onClick={this.emailSentHandl}>
          I will upload documents later
            </a>
          </div>
        </div>
        {
          this.state.modalOpen ? (
            <UploadType
              isOpen={this.state.modalOpen}
              type={this.props[`type${this.props.step}`]}
              modalHandl={this.modalHandl}
              uploadFile={this.sendData}
            />
          ) : null
        }
        <UploadProgress
          done={this.props.done}
          errorDownload={this.state.errorDownload}
          closeErrorWindow={this.closeErrorWindow}
          errorMessage={this.state.errorMessage}
        />
      </React.Fragment>
    );
  }
}

UploadPage.defaultProps = {
  uploaded: [],
  done: false
};

UploadPage.propTypes = {
  showNotification: PropTypes.func.isRequired,
  fileTypeChange: PropTypes.func.isRequired,
  fileSend: PropTypes.func.isRequired,
  fileList: PropTypes.func.isRequired,
  fileStepChange: PropTypes.func.isRequired,
  confirmationChangeHandl: PropTypes.func.isRequired,
  confirmationSend: PropTypes.func.isRequired,
  workingChangeHandl: PropTypes.func.isRequired,
  step: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  type1: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  type2: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  // eslint-disable-next-line
  uploaded: PropTypes.array,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  done: PropTypes.bool,
  fileNotificationLater: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  step: state.file.step,
  type1: state.file.type1,
  type2: state.file.type2,
  progress: state.file.progress,
  done: state.file.done,
  uploaded: state.file.uploaded
});


export default connect(mapStateToProps, containerActions)(UploadPage);



// WEBPACK FOOTER //
// ./src/pages/Upload/index.js